module.exports = __webpack_public_path__ + "img/sirclepos.12ca62fa.jpg";